export const validation = {
  password: "Please enter a Password",
  confirmPassword: "Please enter confirm password",
  passwordField:
    "Password should be atleast 6 to 12 character,\nOne Uppercase, One Lowercase,\nOne Number & special Character",
  email: "Please enter a email ",
  validEmail: "Please enter a valid email address",
  minPhone: "Phone number must be 6 to 16 digits",
  phone: "Phone number is required",
  countryCode: "Country code is required",
  phoneNumberReq: "Please enter the phone number",
  newPassword: "Please enter new password",
  // confirmPassword: "Please enter confirm password",
  confirmPasswordField: "New Password and Confirm Password must be the same",
  currentPassword: "Please enter your current password",
};
